import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'updateSelectedLogIndexMutator',
    function updateSelectedLogIndexMutator(newIndex: number) {
        getStore().selectedLogIndex = newIndex;
    }
);
